module.exports = __webpack_public_path__ + "static/img/tab-ten.34b3506e.png";